jQuery(function($) {
	$('.review-slider').slick({
		dots: false,
		arrow: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		autoplay: false,
		autoplaySpeed: 2000,
	});

	$('.property-image-slider').slick({
		dots: false,
		arrows: true,
		infinite: true,
		centerMode: true,
		centerPadding: '40%',
		slidesToShow: 1,
        variableWidth: true,
		responsive: [
			{
				breakpoint: 1600,
				settings: {
				centerPadding: '30%',
				}
			},
			{
				breakpoint: 800,
				settings: {
				centerPadding: '.1%',
				}
			},

			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		]
	});

	$('a.gallery').featherlightGallery({
		previousIcon: '«',
		nextIcon: '»',
		galleryFadeIn: 100,
		openSpeed: 100
	});

	$("h1:contains('soil')").html(function(_, html) {
		return html.replace(/(in\snew\ssoil)/g, '<span class="font-accent">$1</span>');
	});

	// $(document).on('facetwp-loaded', function () {
	// 	if ('undefined' !== typeof FWP && FWP.loaded && $('body').hasClass('home')) {
	// 		FWP.auto_refresh = false;
	// 	}
	// });

	// $('.facet-search-button').on('click', function (e) {
	// 	e.preventDefault();

	// 	FWP.parseFacets();
	// 	var query = FWP.helper.serialize(FWP.facets, FWP_JSON.prefix);
	// 	window.location = "/properties/?" + query;
	// });
});
